export default __webpack_public_path__ + "static/media/explore-desktop-7.a8070d6b.png";